import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {faUser, faHome, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';

library.add(faUser, faHome, faSignOutAlt)